import { AuthAdminUserInterface } from "../interfaces/AuthAdminUserInterface/AuthAdminUserInterface";
import { CreateAuthAdminUserInterface } from "../interfaces/AuthAdminUserInterface/CreateAuthAdminUserInterface";
import BaseService from "./BaseService";

export class AuthAdminService extends BaseService<AuthAdminUserInterface, CreateAuthAdminUserInterface>{ 
    constructor(){
        let url: string = '/admin-user/admin'
        super(url)
    }
}